<template>
    <div>
        <v-row style="font-size: 12px;">
            <v-col cols="11" sm="6">
                (সার্কুলার নং ১৫/২০০৫ এর ০৪(ক) অনুচ্ছেদ দ্রষ্টব্য)
            </v-col>
            <v-col cols="11" sm="5" style="text-align: right;">
                ফরম - ছ
            </v-col>
        </v-row>
        <div style="margin-top: 5px; text-align: center;">
            রপ্তানি উন্নয়ন ব্যুরো প্রদেয় সনদপত্র<br />
            বাংলাদেশ ফ্রুটস, ভেজিটেবলস এ্যালাইড প্রোডাক্টস এক্সপোর্টারস এসোসিয়েশন ও<br/>বাংলাদেশ এগ্রোপ্রোসেসরস এসোসিয়েশন এর সদস্য নয় এমন রপ্তানিকারকের ক্ষেত্রে প্রযোজ্য<br/>কৃষিপণ্য (শাকসব্জি/ফলমুল) ও প্রক্রিয়াজাত (এগ্রোপ্রোসেসিং) রপ্তানি খাতে ভর্তুকীর আবেদনের সঙ্গে প্রদেয় সনদপত্র।
        </div>
        <v-row style="margin-top: -8px; margin-bottom: -21px;">
            <v-col cols="11" sm="4">
                ১। আবেদনকারী প্রতিষ্ঠানের নামঃ
                <div style="margin-left: 15px;">ঠিকানাঃ</div>
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.SvForm.User.OrganizationName }}
                <div>{{ formData.SvForm.OfficeAddress }}, {{$globalHelpers.getThanaName(formData.SvForm.OfficeThanaId)}}, {{$globalHelpers.getDistrictName(formData.SvForm.OfficeDistrictId)}}</div>
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: -21px;">
            <v-col cols="11" sm="4">
                ২। রপ্তানি ঋণপত্র/রপ্তানি চুক্তিপত্রের নম্বরঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.SvForm.LcNo }}
                <span style="margin-left: 5px;"></span>তারিখঃ {{ $globalHelpers.getFormattedDate(formData.SvForm.LcDate, '', 'DD/MM/YYYY') }}
                <span style="margin-left: 5px;"></span>মূল্যমানঃ {{ $globalHelpers.getCurrencyName(formData.SvForm.LcCurrencyId) }} {{ formData.SvForm.LcValue }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: -21px;">
            <v-col cols="11" sm="4">
                ৩। বিদেশি ক্রেতার নামঃ
                <div style="margin-left: 15px;">ঠিকানাঃ</div>
            </v-col>
            <v-col cols="11" sm="7" v-if="formData.SvForm.Importer">
                {{formData.SvForm.Importer.Name}}
                <div>{{formData.SvForm.DestinationAddress}}, {{formData.SvForm.DestinationCity}}, {{formData.SvForm.DestinationZipCode}}, {{ $globalHelpers.getCountryNameById(formData.SvForm.DestinationCountryId)}}</div>
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: -21px;">
            <v-col cols="11" sm="4">
                ৪। বিদেশি ক্রেতার ব্যাংকের নামঃ
                <div style="margin-left: 15px;">ঠিকানাঃ</div>
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.ImporterBankName }}
                <div>{{ formData.ImporterBankAddress }}</div>
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: 0;">
            <v-col cols="11" sm="4">
                ৫। ক) ইনভয়েস নম্বরঃ
                <div style="margin-left: 15px;  margin-bottom: -21px;">খ) ইনভয়েসে উল্লেখিত পণ্যের পরিমাণঃ</div>
            </v-col>
            <v-col cols="11" sm="7">
                <v-row style="margin-top: 0;">
                    <v-col cols="11" sm="6" style="padding-top: 0; padding-bottom: 0;">{{ formData.SvForm.InvoiceNo }}</v-col>
                    <v-col cols="11" sm="4" style="padding-top: 0; padding-bottom: 0;">তারিখঃ {{ $globalHelpers.getFormattedDate(formData.SvForm.InvoiceDate, '', 'DD/MM/YYYY') }}</v-col>
                </v-row>
                <v-row style="margin-top: 0;">
                    <v-col cols="11" sm="6" style="padding-top: 10px; padding-bottom: 0;">
                        <span v-for="(quantity, i) in materialTotals.hscode.quantities" :key="i"><span v-if="i !== 0">,</span> {{quantity.total}} {{ $globalHelpers.getUnitTypName(quantity.unitTypeId) }}</span>
                    </v-col>
                    <v-col cols="11" sm="4" style="padding-top: 10px; padding-bottom: 0;">মূল্যঃ {{ $globalHelpers.getCurrencyName(formData.SvForm.InvoiceCurrencyId) }} {{ formData.SvForm.InvoiceValue }}</v-col>
                </v-row>
            </v-col>
        </v-row>
        <div style="margin-top: 5px; margin-bottom: -5px;">
            ৬। (১) কৃষিপণ্য রপ্তানির জন্য প্রযোজ্য
            <div style="margin-left: 35px;">রপ্তানি পণ্যের পরিমাণ, মূল্য ও সংগ্রহসূত্রঃ</div>
            <v-simple-table dense style="margin-left: 35px;">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th style="text-align: left;">সরবরাহকারীর নাম ও ঠিকানা</th>
                        <th style="text-align: left;">সরবরাহকৃত পণ্যের বর্ণনা</th>
                        <th style="text-align: right;">পরিমাণ</th>
                        <th style="text-align: right;">মূল্য</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(material, i) in localMaterials_1" :key="i">
                        <td style="text-align: left;">{{ material.SupplierName }}<br />{{ material.SupplierAddress }}</td>
                        <td style="text-align: left;">{{ material.MAterial }}</td>
                        <td style="text-align: right;">{{ material.Qty }} {{ $globalHelpers.getUnitTypName(material.UnitTypeId) }}</td>
                        <td style="text-align: right;">{{ $globalHelpers.getCurrencyName(material.CurrencyId) }} {{ material.Price }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <div class="mt-2 ml-4" style="margin-left: 15px;">(২) প্রক্রিয়াজাত (এগ্রোপ্রোসেসিং) কৃষিপণ্য রপ্তানির জন্য প্রযোজ্যঃ</div>
            <div style="margin-left: 35px;">ক) রপ্তানি পণ্যে ব্যবহৃত স্থানীয় উপকরণাদির বর্ণনাঃ</div>
            <v-simple-table dense style="margin-left: 52px;">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th style="text-align: left;">উপকরণের নাম</th>
                        <th style="text-align: right;">পরিমাণ</th>
                        <th style="text-align: right;">মূল্য</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(material, i) in localMaterials_2" :key="i">
                        <td style="text-align: left;">{{ material.MAterial }}</td>
                        <td style="text-align: right;">{{ material.Qty }} {{ $globalHelpers.getUnitTypName(material.UnitTypeId) }}</td>
                        <td style="text-align: right;">{{ $globalHelpers.getCurrencyName(material.CurrencyId) }} {{ material.Price }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <div class="mt-2" style="margin-left: 35px;">খ) সংগ্রহসূত্র (সরবরাহকারীর নাম ও ঠিকানা)ঃ</div>
            <v-simple-table dense style="margin-left: 52px;">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th style="text-align: left;">সরবরাহকারীর নাম</th>
                        <th style="text-align: right;">ঠিকানা</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(material, i) in localMaterials_2" :key="i">
                        <td style="text-align: left;">{{ material.SupplierName }}</td>
                        <td style="text-align: right;">{{ material.SupplierAddress }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
        <div style="margin-top: 5px;">
            <div>
                ৭। ক) রপ্তানি পণ্যের বর্ণনাঃ
                <v-simple-table dense style="margin-left: 32px;">
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th style="text-align: left;">পণ্যের বিবরণ</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(hsCode, i) in formData.SvForm.SvFormHSCodes" :key="i">
                            <td style="text-align: left;">{{ hsCode.HSCode.Code }}: {{ hsCode.HSCode.Description}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>

            <v-row style="margin-top: 1px;">
                <v-col cols="11" sm="4">
                    <div style="margin-left: 18px;">
                        খ )প্রকৃত রপ্তানিকৃত পণ্যের পরিমাণঃ
                        <div style="margin-left: 187x;">মূল্যঃ</div>
                    </div>
                </v-col>
                <v-col cols="11" sm="7">
                    <span v-for="(quantity, i) in materialTotals.hscode.quantities" :key="i"><span v-if="i !== 0">,</span> {{quantity.total}} {{ $globalHelpers.getUnitTypName(quantity.unitTypeId) }}</span>
                    <div><span v-for="(price, i) in materialTotals.hscode.prices" :key="i"><span v-if="i !== 0">,</span> {{price.total}} {{ $globalHelpers.getCurrencyName(price.currencyId) }}</span></div>
                </v-col>
            </v-row>
        </div>
        <v-row style="margin-top: 0; margin-bottom: -22px;">
            <v-col cols="11" sm="4">
                ৮। জাহাজীকরণের তারিখঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ $globalHelpers.getFormattedDate(formData.SvForm.BLDate, '', 'DD/MM/YYYY') }} <span style="margin-left: 5px;"></span>গন্তব্য বন্দর {{ formData.SvForm.DestinationPort }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: -22px;">
            <v-col cols="11" sm="4">
                ৯। ইএক্সপি নম্বরঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ $globalHelpers.getFormattedEXPNo(formData.SvForm.EXPNo)  }} <span style="margin-left: 5px;"></span>তারিখঃ {{ $globalHelpers.getFormattedDate(formData.SvForm.EXPDate, '', 'DD/MM/YYYY') }} <span style="margin-left: 5px;"></span>মূল্যঃ {{ $globalHelpers.getCurrencyName(formData.SvForm.ExpCurrencyId) }} {{ formData.SvForm.ExpValue }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: -22px;">
            <v-col cols="11" sm="4">
                ১০। মোট প্রত্যাবাসিত রপ্তানি মূল্য (বৈদেশিক মূদ্রায়):
            </v-col>
            <v-col cols="11" sm="7">
                {{ $globalHelpers.getCurrencyName(formData.RepatriatedValueCurrencyId) }} {{ formData.RepatriatedValue }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: -22px;">
            <v-col cols="11" sm="4">
                ১১। প্রত্যাবাসিত রপ্তানি মূল্যের সনদপত্র নম্বরঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.PRCId }} <span style="margin-left: 5px;"></span>তারিখঃ {{ $globalHelpers.getFormattedDate(formData.PRCDate, '', 'DD/MM/YYYY') }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0; margin-bottom: -22px;">
            <v-col cols="11" sm="4">
                ১২। নীট এফওবি মূল্যঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ $globalHelpers.getCurrencyName(formData.RealisedNetFOBValueCurrencyId) }} {{ formData.RealisedNetFOBValue }}
            </v-col>
        </v-row>
        <div class="incentive-footer-declaration">
            <div style="margin-top: 20px; text-align: right;">(রপ্তানিকারকের স্বাক্ষর ও তারিখ)</div>
            <div style="margin-top: 10px;">
                <div class="text-underline">কৃষিপণ্য রপ্তানির জন্যঃ</div>
                এতদ্বারা প্রত্যয়ন করা যাইতেছে যে, উপরোক্ত রপ্তানির কৃষিপণ্য স্থানীয়ভাবে আমাদের নিজস্ব উৎপদিত/স্থানীয় সরবরহকারীদের দ্বারা স্থানীয়ভাবে উৎপাদিত। বিদেশী ক্রেতা/আমদানিকারকের যথার্থতা/বিশ্বাসযোগ্যতা সম্পর্কেও নিশ্চিত করা হইল।
            </div>
            <div style="margin-top: 50px; text-align: right;">(রপ্তানিকারকের স্বাক্ষর ও তারিখ)</div>
            <div style="margin-top: 10px;">
                <div class="text-underline">প্রক্রিয়াজাত (এগ্রোপ্রোসেসিং) কৃষিপণ্য রপ্তানির জন্যঃ</div>
                এতদ্বারা প্রত্যয়ন করা যাইতেছে যে, উপরোক্ত রপ্তানির বিষয়ে ঘোষিত তথ্যাদি সঠিক ও নির্ভুল। ৬নং ক্রমিকে উল্লিখিত উপকরণাদি উল্লিখিত সরবরাহকারীদের খামারে/ আমাদের নিজস্ব খামারে স্থানীয়ভাবে উৎপাদিত। বিদেশী ক্রেতার/ আমদানিকারকের যথার্থতা/বিশ্বাসযোগ্যতা সম্পর্কেও নিশ্চিত করা হলো।
            </div>
            <div style="margin-top: 50px; text-align: right;">(রপ্তানিকারকের স্বাক্ষর ও তারিখ)</div>
            <div style="margin-top: 10px;">
                উপরেল্লিখিত অনুচ্ছেদগুলি যথাযথভাবে যাচাইপূর্বক সঠিক পাওয়া গিয়েছে। কৃষিপণ্য (শাকসব্জি/ফলমুল) ও প্রক্রিয়াজাত (এগ্রোপ্রোসেসিং) কৃষিপণ্য রপ্তানির বিপরীতে প্রত্যাবসিত মূল্যের অনুকুলে উপরোক্ত রপ্তানিকারককে ভর্তুকি প্রদানের জন্য সুপারিশ করা হইল।
            </div>
            <div style="margin-top: 40px; text-align: right;">রপ্তানি উন্নয়ন ব্যুরোর দুইজন কর্মকর্তার স্বাক্ষর ও তারিখ</div>
        </div>

        <div class="incentive-footer-warning">
            কোন প্রকার ঘষামাজা, কাটাছেড়া বা সংশোধন করা হলে এই প্রত্যয়নপত্র বাতিল বলে গণ্য হবে।
        </div>
    </div>
</template>

<script>
export default {
    name: "IncentiveForm3",
    data: function() {
        return {}
    },
    props: {
        formData: {
            type: Object,
            default: ()=> null
        },
        materialTotals: {
            type: Object,
            default: ()=> null
        },
    },
    computed:{
        localMaterials_1: function (){
            return this.formData.IncentiveFormLocalMaterials.filter(material => material.Type === 1);
        },
        localMaterials_2: function (){
            return this.formData.IncentiveFormLocalMaterials.filter(material => material.Type === 2);
        },
    },
    methods: {

    },
}
</script>

<style scoped>
    table tr td, table tr th{
        padding: 0 !important;
        margin: 0 !important;
        height: 5px !important;
    }
</style>